import { Box, Typography, TextField, MenuItem, Select, CircularProgress } from "@mui/material";

export default function SuggestedFeedbackSection({ 
  suggestedFeedback, 
  setSuggestedFeedback, 
  suggestedAreasOfImprovement, 
  setSuggestedAreasOfImprovement,
  score,
  setScore,
  isGeneratingFeedback
}) {
  return (
    <Box mb={4}>
      <Typography variant="h5" color="primary" gutterBottom>
        Puntaje y Feedback Sugerido
      </Typography>

      <Select
        value={score}
        onChange={(e) => setScore(e.target.value)}
        displayEmpty
        fullWidth
        sx={{ mb: 3 }}
      >
        <MenuItem value="" disabled>Seleccionar puntaje general</MenuItem>
        <MenuItem value={5}>1 - Excede ampliamente las expectativas</MenuItem>
        <MenuItem value={4}>2 - Desempeño por encima del esperado</MenuItem>
        <MenuItem value={3}>3 - Desempeño esperado</MenuItem>
        <MenuItem value={2}>4 - Desempeño por debajo del esperado</MenuItem>
        <MenuItem value={1}>5 - Bastante alejado del esperado</MenuItem>
      </Select>

      {isGeneratingFeedback ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 4 }}>
          <CircularProgress />
          <Typography variant="body2" color="textSecondary" mt={2}>
            Generando feedback automático...
          </Typography>
        </Box>
      ) : (
        <>
          <Box mb={3}>
            <Typography variant="subtitle1" gutterBottom>
              Fortalezas
            </Typography>
            <TextField
              multiline
              fullWidth
              minRows={6}
              value={suggestedFeedback}
              onChange={(e) => setSuggestedFeedback(e.target.value)}
            />
          </Box>

          <Box>
            <Typography variant="subtitle1" gutterBottom>
              Áreas de Mejora
            </Typography>
            <TextField
              multiline
              fullWidth
              minRows={6}
              value={suggestedAreasOfImprovement}
              onChange={(e) => setSuggestedAreasOfImprovement(e.target.value)}
            />
          </Box>
        </>
      )}
    </Box>
  );
}
